import {
  FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS,
  FETCH_DOWNLOAD_DELETE_LANDING_BEGIN,
  FETCH_DOWNLOAD_DELETE_LANDING_FAILURE
} from "../actions/types";

import {
  HANDLE_FILE_AVAILABLE_CLICK,
  AFFIDAVIT_CONSENT_SUCCESS
} from "../../DownloadAndDelete/actions/types";

const initialState = {
  agentDetailsData: [],
  status: null,
  requestType: "",
  deleteRequestType: "",
  dateOfRequest: "",
  downloadAvailabilityDeadline: "",
  noOfAffidavitDownloadRemaining: null,
  noOfRegularDownloadRemaining: null,
  downloadReady: false,
  maximumDownloadsReached: false,
  requestCategories: [],
  fileSize: "",
  hasMadeRequest: false,
  numberOfDays: 0,
  loading: false,
  error: false,
  mtnList: [],
  encryptedMtn: "",
  requestedChannel: "",
  consentedDate: "",
  shouldBannerRender: false,
  fileFormat: "",
  nextRollOffDateAffidavitDownload: "",
  nextRollOffDateRegularDownload: "",
  noOfPwdNotificationRemaining: null,
  emailId: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case AFFIDAVIT_CONSENT_SUCCESS:
      return {
        ...state,
        consentedDate: "SUCCESS"
      };
    case HANDLE_FILE_AVAILABLE_CLICK:
      return {
        ...state,
        ...action.payload
      };
    case FETCH_DOWNLOAD_DELETE_LANDING_BEGIN:
      return {
        ...state,
        ...initialState,
        loading: true,
        error: false
      };
    case FETCH_DOWNLOAD_DELETE_LANDING_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false
      };
    case FETCH_DOWNLOAD_DELETE_LANDING_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    default:
      return state;
  }
};
